// Local Host Setup

// import axios from "axios";
// export const http = axios.create({ baseURL: "http://localhost:5009/" });
// export const barcode = "http://localhost:5009/images/barcodes/";
// export const server = "http://localhost:5009/";
// export const serverSocket = "http://localhost:5009/";
// export const apiUrlPatients = "http://localhost:5009/prijem/pacijenti/";
// export const apiUrlObradaPregled = "http://localhost:5009/obrada/pregled/";
// export const apiUrlNalaziPregled = "http://localhost:5009/nalazi/pregled";
// export const apiUrlNalaziOutbox = "http://localhost:5009/nalazi/outbox";
// export const apiUrlLabAssays = "http://localhost:5009/assays/lab";
// export const apiUrlAnaAssays = "http://localhost:5009/assays/ana";
// export const apiUrlControlClone = "http://localhost:5009/control/clone";
// export const apiUrlControlEdit = "http://localhost:5009/control/edit";
// export const apiUrlControlResults = "http://localhost:5009/control/results";
// export const apiUrlIntegration = "http://localhost:5009/api/pregled";
// export const apiUrlProdukt = "http://localhost:5009/inventar/produkti";
// export const apiUrlUgovor = "http://localhost:5009/inventar/ugovori";
// export const apiUrlStanje = "http://localhost:5009/inventar/stanje";
// export const apiUrlNarudzbenica = "http://localhost:5009/inventar/narudzbenice";
// export const apiUrlUlaz = "http://localhost:5009/inventar/ulazpregled";
// export const apiUrlIzlaz = "http://localhost:5009/inventar/izlazpregled";

// Server Setup

import axios from "axios";
export const http = axios.create({ baseURL: "https://bihlab.atom-lis.com/" });
export const barcode = "https://bihlab.atom-lis.com/images/barcodes/";
export const server = "https://bihlab.atom-lis.com/";
export const serverSocket = "https://bihlab.atom-lis.com/";
export const apiUrlPatients = "https://bihlab.atom-lis.com/prijem/pacijenti/";
export const apiUrlObradaPregled = "https://bihlab.atom-lis.com/obrada/pregled/";
export const apiUrlNalaziPregled = "https://bihlab.atom-lis.com/nalazi/pregled";
export const apiUrlNalaziOutbox = "https://bihlab.atom-lis.com/nalazi/outbox";
export const apiUrlLabAssays = "https://bihlab.atom-lis.com/assays/lab";
export const apiUrlAnaAssays = "https://bihlab.atom-lis.com/assays/ana";
export const apiUrlControlClone = "https://bihlab.atom-lis.com/control/clone";
export const apiUrlControlEdit = "https://bihlab.atom-lis.com/control/edit";
export const apiUrlControlResults = "https://bihlab.atom-lis.com/control/results";
export const apiUrlIntegration = "https://bihlab.atom-lis.com/api/pregled";
export const apiUrlProdukt = "https://bihlab.atom-lis.com/inventar/produkti";
export const apiUrlUgovor = "https://bihlab.atom-lis.com/inventar/ugovori";
export const apiUrlStanje = "https://bihlab.atom-lis.com/inventar/stanje";
export const apiUrlNarudzbenica = "https://bihlab.atom-lis.com/inventar/narudzbenice";
export const apiUrlUlaz = "https://bihlab.atom-lis.com/inventar/ulazpregled";
export const apiUrlIzlaz = "https://bihlab.atom-lis.com/inventar/izlazpregled";


//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = 1wn0
// module chunks = 63